import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'
import { injectIntl } from 'react-intl'
import messages from './messages'

import RegionTools from 'utils/regions/regionTools'

class FilterModal extends Component {
  constructor(props) {
    super(props)

    const {
      intl: { formatMessage }
    } = props

    this.formatMessage = formatMessage

    this.state = {}
  }

  renderBody() {
    let regionName = this.props.regionName
    let regionNumber = this.props.regionsData.length

    let bodyIntro =
			this.props.type === 'all'
			  ? this.formatMessage(messages.allRegionsModalBodyIntro, { regionName, regionNumber })
			  : this.formatMessage(messages.referenceRegionsModalBodyIntro, { regionName, regionNumber })

    let regionsDataByCountry = RegionTools.getRegionsDataByCountry(this.props.regionsData)
    let sortedCountryCodes = RegionTools.getSortedCountryCodesByCountryName({ regionsDataByCountry })

    let processedData = []
    for (let i = 0; i < sortedCountryCodes.length; i++) {
      let actualCountryData = regionsDataByCountry[sortedCountryCodes[i]]
      actualCountryData.regions = RegionTools.getSortedRegionsByRegionName({ regionsData: actualCountryData.regions })

      let processedCountry = {
        countryCode: sortedCountryCodes[i],
        countryFullName: actualCountryData.countryFullName,
        code: sortedCountryCodes[i],
        name: actualCountryData.countryFullName,
        isCountry: true
      }
      processedData.push(processedCountry)
      actualCountryData.regions.forEach(region => {
        let processedRegion = region
        processedRegion.countryCode = sortedCountryCodes[i]
        processedRegion.countryFullName = actualCountryData.countryFullName
        processedRegion.isCountry = false
        processedData.push(processedRegion)
      })
    }
    let bodyItems = []
    processedData.forEach(item => {
      if (item.isCountry) {
        bodyItems.push(<br key={`key-${item.name}`} />)
        bodyItems.push(
          <dt className="ork-epigraph ork-epigraph--small ork-u-mb" key={`c-${item.name}`}>
            <i>{item.name}</i>
          </dt>
        )
      } else {
        bodyItems.push(
          <dd key={`r-${item.name}`} className="ork-u-mb-half ork-u-ml">
            {item.name} ({item.code})
          </dd>
        )
      }
    })

    let body = <dl>{bodyItems}</dl>

    return { bodyIntro, body }
  }

  render() {
    let modalTitle
    if (this.props.type === 'all') {
      modalTitle = this.formatMessage(messages.showAllRegions)
    } else {
      modalTitle = this.formatMessage(messages.showReferenceRegions)
    }

    let { bodyIntro, body } = this.renderBody()

    return (
      <Modal show={this.props.open} onHide={this.props.closeModal}>
        <Modal.Header closeButton>
          <Modal.Title id="modal-rango-fechas-01-label">{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="ork-modal-body--border-bottom">
          <div dangerouslySetInnerHTML={{ __html: bodyIntro }} />
          <br />
          {body}
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-sm btn-primary" onClick={this.props.closeModal}>
            <i className="fal fa-check fa-lg" /> <span className="ork-u-ml-half">{this.formatMessage(messages.accept)}</span>
          </button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default injectIntl(FilterModal)



// WEBPACK FOOTER //
// ./src/modules/Filters/FilterModal/FilterModal.jsx